export const formatNumberToMoney = (amount, decimals) => {
    let formatting_options = {
       style: 'currency',
       currency: 'MXN',
       minimumFractionDigits: decimals,
    }
    // users can see how locale passed as a parameter.
    let dollarString = new Intl.NumberFormat("es-MX", formatting_options);
    let finalString = dollarString.format(amount);
    return finalString;
} 